import React from "react";
import Chart from "react-apexcharts";
import useMonthlyRevenue from "../hooks/useMonthlyRevenue";
import "./stickyloder.css";

const RevenueReportChart = () => {
  const { data, isLoading, error } = useMonthlyRevenue();

  const months =
    data?.data?.map((item) =>
      new Date(item.month + "-01").toLocaleString("en-GB", {
        month: "short",
        year: "numeric",
      })
    ) || [];

  const revenues =
    data?.data?.map((item) => Number(item.total_revenue_gbp || 0)) || [];

  const options = {
    chart: {
      type: "area",
      height: 350,
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#00B894"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories: months,
    },
    yaxis: {
      labels: {
        formatter: (val) => `£${val.toFixed(2)}`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `£${val.toFixed(2)}`,
      },
    },
  };

  const series = [
    {
      name: "Revenue (GBP)",
      data: revenues,
    },
  ];

 if (isLoading)
  return (
    <div className="top-loader">
      <div className="top-loader-bar"></div>
    </div>
  );


  if (error) return <div>Failed to load revenue chart</div>;

  return (
    <div className="card" style={{ borderRadius: "15px", padding: "20px" }}>
      <h4 style={{ marginBottom: "15px" }}>Monthly Revenue Report (£)</h4>
      <Chart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default RevenueReportChart;
